














































































import { Component, Mixins, Prop, Watch } from 'vue-property-decorator';
import TextOutput from '~/mixins/TextOutput';
import BrandCard from '~/components/BrandCard.vue';
import { Getter, State } from 'vuex-class';
import ItemList from './ItemList.vue';
import itemsForSaleByGala from '~/queries/paginatedStoreItems.gql';
import { IGameItemForSaleByGala } from '~/store/games/types';
import { IGame } from '~/store/games/types';
import { CopyToClipboard } from '~/mixins';
import { IInventoryCollection } from '../../../store/cms_content/types';
import { IOrderDetails } from '../../../types/order-details';
import OrderDetails from './OrderDetails.vue';

@Component({
  components: {
    BrandCard,
    ItemList,
    OrderDetails,
  },
})
export default class OrderConfirmation extends Mixins(
  TextOutput,
  CopyToClipboard,
) {
  @Prop(Object) readonly orderDetails!: IOrderDetails;
  @Getter('inventoryIconForCollectionName', { namespace: 'cmsContent' })
  collectionIcons!: Record<string, IInventoryCollection | undefined>;
  @State(games => games.games, { namespace: 'games' })
  games!: IGame[];
  relatedItems: IGameItemForSaleByGala[] = [];
  productTypes = {
    ethereum: ['item-pack', 'item'],
    gyri: ['galachain-item', 'galachain-allowance', 'item-pack-mix'],
    game: ['game-gem', 'spidertanks-profile-item'],
  };

  created() {
    if (this.orderDetails) {
      this.getRelatedItems(this.orderDetails);
    }
  }

  get nextSteps() {
    return [
      {
        icon: require('@/assets/icons/icon_blockchain_pending.png'),
        text: this.$t(
          'components.games.items.orderConfirmation.fundsSent',
        ) as string,
      },
      {
        icon: require('@/assets/icons/icon_fundsreceive.png'),
        text: this.$t(
          'components.games.items.orderConfirmation.fundsReceived',
        ) as string,
      },
      {
        icon: require('@/assets/icons/icon_white_checkmark.png'),
        text: this.getOrderFinishedText(),
      },
    ];
  }

  getOrderFinishedText() {
    const productName = this.orderDetails.product.name.toLowerCase();
    return productName.includes('node license')
      ? (this.$t(
          'components.games.items.orderConfirmation.readyForUse',
        ) as string)
      : productName.includes('gold membership')
      ? (this.$t(
          'components.games.items.orderConfirmation.goldMembershipActive',
        ) as string)
      : (this.$t(
          'components.games.items.orderConfirmation.itemsTransferred',
        ) as string);
  }

  @Watch('orderDetails')
  async getRelatedItems(orderDetails: IOrderDetails) {
    const paginatedStoreItemsInput = {
      currency: '',
      limit: 6,
      page: 1,
      platform: 'platform',
      stringFilterOptions: [
        {
          comparator: 'in',
          field: 'game',
          value: [orderDetails.product.game],
        },
      ],
      sortOptions: {
        sortDirection: -1,
        sortField: 'dateAvailable',
      },
    };
    const results = (await this.$apollo.query({
      query: itemsForSaleByGala,
      variables: {
        paginatedStoreItemsInput,
      },
      fetchPolicy: 'no-cache',
    })) as {
      data: {
        paginatedStoreItems: {
          products: any[];
          page: number;
          total: number;
          lastPage?: number;
        };
      };
    };

    if (results?.data?.paginatedStoreItems) {
      const { products } = results.data.paginatedStoreItems;
      this.relatedItems = products;
    }
  }

  get etherscanLink() {
    if (this.orderDetails.paymentHash) {
      return `https://${
        process.env.networkType === 'testnet' ? 'sepolia.' : ''
      }etherscan.io/tx/${this.orderDetails.paymentHash}`;
    }

    return '';
  }
}
